import { createStructuredSelector } from "reselect";
import {
    KPI_MATRIX_LIST,
    KPI_MATRIX_LIST_SUCCESS,
    KPI_MATRIX_LIST_ERROR,
    KPI_MATRIX_LIST_ITB,
    KPI_MATRIX_LIST_ITB_SUCCESS,
    KPI_MATRIX_LIST_ITB_ERROR,
    KPI_MATRIX_LIST_ANUAL_BASE_LINE,
    KPI_MATRIX_LIST_ANUAL_BASE_LINE_SUCCESS,
    KPI_MATRIX_LIST_ANUAL_BASE_LINE_ERROR,
    KPI_MATRIX_DETAIL,
    KPI_MATRIX_DETAIL_SUCCESS,
    KPI_MATRIX_DETAIL_ERROR,
    KPI_MATRIX_DATA_LIST,
    KPI_MATRIX_DATA_LIST_SUCCESS,
    KPI_MATRIX_DATA_LIST_ERROR,
    KPI_MATRIX_TAB_SET,
    KPI_MATRIX_VIEW_MODAL_SET,
    KPI_MATRIX_GRAPH_3MORE_LIST,
    KPI_MATRIX_GRAPH_3MORE_LIST_SUCCESS,
    KPI_MATRIX_GRAPH_3MORE_LIST_ERROR,
    KPI_MATRIX_GRAPH_BIDDER_CLAVES_LIST,
    KPI_MATRIX_GRAPH_BIDDER_CLAVES_LIST_SUCCESS,
    KPI_MATRIX_GRAPH_BIDDER_CLAVES_LIST_ERROR,
    KPI_MATRIX_GRAPH_PIE_LIST,
    KPI_MATRIX_GRAPH_PIE_LIST_SUCCESS,
    KPI_MATRIX_GRAPH_PIE_LIST_ERROR,
    KPI_MATRIX_GRAPH_BAR_LIST,
    KPI_MATRIX_GRAPH_BAR_LIST_SUCCESS,
    KPI_MATRIX_GRAPH_BAR_LIST_ERROR,
    KPI_MATRIX_TAG_SAVINGS_LIST,
    KPI_MATRIX_TAG_SAVINGS_LIST_SUCCESS,
    KPI_MATRIX_TAG_SAVINGS_LIST_ERROR,
    KPI_MATRIX_TOTAL_PZS_LIST,
    KPI_MATRIX_TOTAL_PZS_LIST_SUCCESS,
    KPI_MATRIX_TOTAL_PZS_LIST_ERROR,
    KPI_MATRIX_BIDDER_LIST,
    KPI_MATRIX_BIDDER_LIST_SUCCESS,
    KPI_MATRIX_BIDDER_LIST_ERROR,
    KPI_MATRIX_BIDDERMC_LIST,
    KPI_MATRIX_BIDDERMC_LIST_SUCCESS,
    KPI_MATRIX_BIDDERMC_LIST_ERROR,
    KPI_MATRIX_BIDDERMED2021_LIST,
    KPI_MATRIX_BIDDERMED2021_LIST_SUCCESS,
    KPI_MATRIX_BIDDERMED2021_LIST_ERROR,
    KPI_MATRIX_BIDDERMC2021_LIST,
    KPI_MATRIX_BIDDERMC2021_LIST_SUCCESS,
    KPI_MATRIX_BIDDERMC2021_LIST_ERROR,
    KPI_FUNNEL_LIST,
    KPI_FUNNEL_LIST_SUCCESS,
    KPI_FUNNEL_LIST_ERROR,
    KPI_FUNNELMC_LIST,
    KPI_FUNNELMC_LIST_SUCCESS,
    KPI_FUNNELMC_LIST_ERROR,

    KPI_EVALUATIONS,
    KPI_EVALUATIONS_SUCCESS,
    KPI_EVALUATIONS_ERROR,
    KPI_EVALUATIONS_SEARCH_SET,
    KPI_EVALUATIONS_SEARCH_CHANGE,
    KPI_EVALUATIONS_TAB_SET,
    KPI_FUNNEL_PROCCESS_LIST,
    KPI_FUNNEL_PROCCESS_LIST_SUCCESS,
    KPI_FUNNEL_PROCCESS_LIST_ERROR
} from "../actions";

export const NAME = 'kpiMatrix';

export const KpiMatrixList = (page, num_page, orderBy, filters, stateFilter) => ({
    type: KPI_MATRIX_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const KpiMatrixListSuccess = (data) => ({
    type: KPI_MATRIX_LIST_SUCCESS,
    payload: data
});

export const KpiMatrixListError = (error) => ({
    type: KPI_MATRIX_LIST_ERROR,
    payload: error
});

export const KpiMatrixListITB = (data) => ({
    type: KPI_MATRIX_LIST_ITB,
    payload: data
});

export const KpiMatrixListITBSuccess = (data) => ({
    type: KPI_MATRIX_LIST_ITB_SUCCESS,
    payload: data
});

export const KpiMatrixListITBError = (error) => ({
    type: KPI_MATRIX_LIST_ITB_ERROR,
    payload: error
});

export const KpiMatrixListAnualBaseLine = (data) => ({
    type: KPI_MATRIX_LIST_ANUAL_BASE_LINE,
    payload: data
});

export const KpiMatrixListAnualBaseLineSuccess = (data) => ({
    type: KPI_MATRIX_LIST_ANUAL_BASE_LINE_SUCCESS,
    payload: data
});

export const KpiMatrixListAnualBaseLineError = (error) => ({
    type: KPI_MATRIX_LIST_ANUAL_BASE_LINE_ERROR,
    payload: error
});
export const KpiMatrixViewModalSet = (data) => ({
    type: KPI_MATRIX_VIEW_MODAL_SET,
    payload: data
});

export const KpiMatrixDetail = (data) => ({
    type: KPI_MATRIX_DETAIL,
    payload: data
});

export const KpiMatrixDetailSuccess = (data) => ({
    type: KPI_MATRIX_DETAIL_SUCCESS,
    payload: data
});

export const KpiMatrixDetailError = (error) => ({
    type: KPI_MATRIX_DETAIL_ERROR,
    payload: error
});

export const KpiMatrixDataList = (data) => ({
    type: KPI_MATRIX_DATA_LIST,
    payload: data
});

export const KpiMatrixDataListSuccess = (data) => ({
    type: KPI_MATRIX_DATA_LIST_SUCCESS,
    payload: data
});

export const KpiMatrixDataListError = (error) => ({
    type: KPI_MATRIX_DATA_LIST_ERROR,
    payload: error
});

export const KpiMatrixGraph3MoreList = (data) => ({
    type: KPI_MATRIX_GRAPH_3MORE_LIST,
    payload: data
});

export const KpiMatrixGraph3MoreListSuccess = (data) => ({
    type: KPI_MATRIX_GRAPH_3MORE_LIST_SUCCESS,
    payload: data
});

export const KpiMatrixGraph3MoreListError = (error) => ({
    type: KPI_MATRIX_GRAPH_3MORE_LIST_ERROR,
    payload: error
});

export const KpiMatrixGraphBidderClavesList = (data) => ({
    type: KPI_MATRIX_GRAPH_BIDDER_CLAVES_LIST,
    payload: data
});

export const KpiMatrixGraphBidderClavesListSuccess = (data) => ({
    type: KPI_MATRIX_GRAPH_BIDDER_CLAVES_LIST_SUCCESS,
    payload: data
});

export const KpiMatrixGraphBidderClavesListError = (error) => ({
    type: KPI_MATRIX_GRAPH_BIDDER_CLAVES_LIST_ERROR,
    payload: error
});

export const KpiMatrixGraphPieList = (data) => ({
    type: KPI_MATRIX_GRAPH_PIE_LIST,
    payload: data
});

export const KpiMatrixGraphPieListSuccess = (data) => ({
    type: KPI_MATRIX_GRAPH_PIE_LIST_SUCCESS,
    payload: data
});

export const KpiMatrixGraphPieListError = (error) => ({
    type: KPI_MATRIX_GRAPH_PIE_LIST_ERROR,
    payload: error
});

export const KpiMatrixGraphBarList = (data) => ({
    type: KPI_MATRIX_GRAPH_BAR_LIST,
    payload: data
});

export const KpiMatrixGraphBarListSuccess = (data) => ({
    type: KPI_MATRIX_GRAPH_BAR_LIST_SUCCESS,
    payload: data
});

export const KpiMatrixGraphBarListError = (error) => ({
    type: KPI_MATRIX_GRAPH_BAR_LIST_ERROR,
    payload: error
});

export const KpiMatrixTagSavingsList = (data) => ({
    type: KPI_MATRIX_TAG_SAVINGS_LIST,
    payload: data
});

export const KpiMatrixTagSavingsListSuccess = (data) => ({
    type: KPI_MATRIX_TAG_SAVINGS_LIST_SUCCESS,
    payload: data
});

export const KpiMatrixTagSavingsListError = (error) => ({
    type: KPI_MATRIX_TAG_SAVINGS_LIST_ERROR,
    payload: error
});

export const KpiMatrixTotalPzsList = (data) => ({
    type: KPI_MATRIX_TOTAL_PZS_LIST,
    payload: data
});

export const KpiMatrixTotalPzsListSuccess = (data) => ({
    type: KPI_MATRIX_TOTAL_PZS_LIST_SUCCESS,
    payload: data
});

export const KpiMatrixTotalPzsListError = (error) => ({
    type: KPI_MATRIX_TOTAL_PZS_LIST_ERROR,
    payload: error
});

export const KpiMatrixBidderList = (data) => ({
    type: KPI_MATRIX_BIDDER_LIST,
    payload: data
});

export const KpiMatrixBidderListSuccess = (data) => ({
    type: KPI_MATRIX_BIDDER_LIST_SUCCESS,
    payload: data
});

export const KpiMatrixBidderListError = (error) => ({
    type: KPI_MATRIX_BIDDER_LIST_ERROR,
    payload: error
});

export const KpiMatrixBidderMcList = (data) => ({
    type: KPI_MATRIX_BIDDERMC_LIST,
    payload: data
});

export const KpiMatrixBidderMcListSuccess = (data) => ({
    type: KPI_MATRIX_BIDDERMC_LIST_SUCCESS,
    payload: data
});

export const KpiMatrixBidderMcListError = (error) => ({
    type: KPI_MATRIX_BIDDERMC_LIST_ERROR,
    payload: error
});

export const KpiMatrixBidderMed2021List = (data) => ({
    type: KPI_MATRIX_BIDDERMED2021_LIST,
    payload: data
});

export const KpiMatrixBidderMed2021ListSuccess = (data) => ({
    type: KPI_MATRIX_BIDDERMED2021_LIST_SUCCESS,
    payload: data
});

export const KpiMatrixBidderMed2021ListError = (error) => ({
    type: KPI_MATRIX_BIDDERMED2021_LIST_ERROR,
    payload: error
});

export const KpiMatrixBidderMc2021List = (data) => ({
    type: KPI_MATRIX_BIDDERMC2021_LIST,
    payload: data
});

export const KpiMatrixBidderMc2021ListSuccess = (data) => ({
    type: KPI_MATRIX_BIDDERMC2021_LIST_SUCCESS,
    payload: data
});

export const KpiMatrixBidderMc2021ListError = (error) => ({
    type: KPI_MATRIX_BIDDERMC2021_LIST_ERROR,
    payload: error
});

export const KpiFunnelList = (data) => ({
    type: KPI_FUNNEL_LIST,
    payload: data
});

export const KpiFunnelListSuccess = (data) => ({
    type: KPI_FUNNEL_LIST_SUCCESS,
    payload: data
});

export const KpiFunnelListError = (error) => ({
    type: KPI_FUNNEL_LIST_ERROR,
    payload: error
});

export const KpiFunnelMcList = (data) => ({
    type: KPI_FUNNELMC_LIST,
    payload: data
});

export const KpiFunnelMcListSuccess = (data) => ({
    type: KPI_FUNNELMC_LIST_SUCCESS,
    payload: data
});

export const KpiFunnelMcListError = (error) => ({
    type: KPI_FUNNELMC_LIST_ERROR,
    payload: error
});


export const KpiMatrixTabSet = (data) => ({
    type: KPI_MATRIX_TAB_SET,
    payload: data
});

export const KpiEvaluations = (filters) => ({
    type: KPI_EVALUATIONS,
    payload: { filters: filters }
});

export const KpiEvaluationsSuccess = (data) => ({
    type: KPI_EVALUATIONS_SUCCESS,
    payload: data
});

export const KpiEvaluationsError = (error) => ({
    type: KPI_EVALUATIONS_ERROR,
    payload: error
});

export const KpiEvaluationsSearchSet = (data) => ({
    type: KPI_EVALUATIONS_SEARCH_SET,
    payload: data
});

export const KpiEvaluationsSearchChangeSet = (data) => ({
    type: KPI_EVALUATIONS_SEARCH_CHANGE,
    payload: data
});

export const KpiEvaluationsTabSet = (data) => ({
    type: KPI_EVALUATIONS_TAB_SET,
    payload: data
});

export const KpiFunnelProccessList = (filters) => ({
    type: KPI_FUNNEL_PROCCESS_LIST,
    payload: { filters: filters }
});

export const KpiFunnelProccessListSuccess = (data) => ({
    type: KPI_FUNNEL_PROCCESS_LIST_SUCCESS,
    payload: data
});

export const KpiFunnelProccessListError = (error) => ({
    type: KPI_FUNNEL_PROCCESS_LIST_ERROR,
    payload: error
});

const kpiMatrix = (state) => state[NAME];

export const KpiMatrixSelector = createStructuredSelector({
    kpiMatrix
})
